import React, { useEffect, useRef, useState } from "react";
import "./HereToMakeItEasy.scss";
import DownChevron from "../../images/down-chevron.svg";
import useCityContent from "../../hooks/useCityContent";
const HereToMakeItEasy = () => {
  const { cityData } = useCityContent();
  const [activeIndex, setActiveIndex] = useState(null);
  const contentRefs = useRef([]);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  useEffect(() => {
    contentRefs.current.forEach((content, i) => {
      if (content) {
        if (i === activeIndex) {
          content.style.maxHeight = `${content.scrollHeight}px`;
        } else {
          content.style.maxHeight = "0"; // Collapse smoothly
        }
      }
    });
  }, [activeIndex]);

  return (
    <section className="faq section-padding-lg">
      <div className="container">
        <div className="faq-accordion">
          <div className="faq-accordion-details section-header">
            <h2>
              We’re here <span>to make it easy!</span>
            </h2>
          </div>
          {cityData.faq_question_answers.map((item, index) => (
            <div
              className={`accordion-item ${activeIndex === index ? "active" : ""
                }`}
              key={index}
            >
              <div
                className="accordion-label"
                onClick={() => toggleAccordion(index)}
              >
                <span className="accordion-question">{item.question}</span>
                <span className="icon">
                  <figure>
                    <img src={DownChevron} alt="chevron-arrow" loading="lazy" />
                  </figure>
                </span>
              </div>
              <div
                className="accordion-content"
                ref={(el) => (contentRefs.current[index] = el)}
                style={{
                  overflow: "hidden",
                  transition: "max-height 0.5s ease",
                }}
              >
                <p>{item.answer}</p>
                <br />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HereToMakeItEasy;
